import { apiClient } from '../../../../core/api/client';

export type FeaturedResource = {
  id: string;
  title: string;
  description: string;
  type: 'ARTICLE' | 'VIDEO' | 'PODCAST' | 'GUIDE';
  category: string;
  thumbnailUrl: string | null;
  url: string;
};

type ResourceListItem = {
  id: string;
  title: string;
  excerpt: string;
  seoUrl: string;
  type: {
    id: string;
    name: string;
  };
  image: {
    id: string;
    fileUrl: string;
    formats?: any;
  } | null;
  categories: Array<{
    id: string;
    name: string;
  }>;
  tags: Array<{
    id: string;
    name: string;
  }>;
  author: {
    id: string;
    name: string;
    type: 'external' | 'provider';
  } | null;
  isFavorited: boolean;
  isFeaturedForPro: boolean;
  publishedAt: string;
};

type ResourceListResponse = {
  data: ResourceListItem[];
  total: number;
  page: number;
  limit: number;
  hasMore: boolean;
};

/**
 * Fetch featured resources for Financial Advisor dashboard
 *
 * @returns Array of featured resources
 * @throws Error if request fails
 */
export async function fetchFeaturedResources(): Promise<FeaturedResource[]> {
  const response = await apiClient.get<FeaturedResource[]>('/resources/featured');

  return response.data;
}

/**
 * Fetch favorited resources for Financial Advisor dashboard
 *
 * @returns Array of favorited resources
 * @throws Error if request fails
 */
export async function fetchFavoritedResources(): Promise<FeaturedResource[]> {
  const response = await apiClient.get<ResourceListResponse>('/resources', {
    params: {
      favorited: true,
      limit: 10,
      page: 1,
    }
  });

  // Transform backend response to match FeaturedResource type
  return response.data.data.map((item) => ({
    id: item.id,
    title: item.title,
    description: item.excerpt,
    type: item.type.name.toUpperCase() as 'ARTICLE' | 'VIDEO' | 'PODCAST' | 'GUIDE',
    category: item.categories[0]?.name || 'Uncategorized',
    thumbnailUrl: item.image?.fileUrl || null,
    url: `/resource-hub-detail/${item.seoUrl}`,
  }));
}

